import React from 'react';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import TableButtonsActions, {
	ActionConfig,
} from '../../../Components/TableButtonsActions/TableButtonsActions';
import act02 from '../../../assets/img/icons/actions/gridicons_cross-circle.svg';
import check from '../../../assets/img/icons/check.svg';
import {Transaction} from '../../../types/TypesUserAccounts';
import {getAvailableActions} from './actionsHelper';
import {
	useBillingApproveMutation,
	useBillingConfirmMutation,
	useBillingReceiveMutation,
	useBillingRejectMutation,
} from '../../../redux/userBillingApi';
import {handleApiCall} from '../../../assets/utils/utils';

type Props = {
	transaction: Transaction;
};
const TransactionsActions: React.FC<Props> = ({transaction}) => {
	const {t} = useTranslation();
	const [approve] = useBillingApproveMutation();
	const [reject] = useBillingRejectMutation();
	const [confirm] = useBillingConfirmMutation();
	const [receive] = useBillingReceiveMutation();
	// === HANDLERS ===
	const handlers = {
		approve: async (id: number) => {
			await handleApiCall({
				apiCall: () => approve(id),
				onSuccess: () => toast.success('Успішно'),
			});
		},
		reject: async (id: number) => {
			await handleApiCall({
				apiCall: () => reject(id),
				onSuccess: () => toast.success('Успішно'),
			});
		},
		confirm: async (id: number) => {
			await handleApiCall({
				apiCall: () => confirm(id),
				onSuccess: () => toast.success('Успішно'),
			});
		},

		receive: async (id: number) => {
			await handleApiCall({
				apiCall: () => receive(id),
				onSuccess: () => toast.success('Успішно'),
			});
		},
	};

	const actions: ActionConfig[] = [
		{
			type: 'approve',
			icon: check,
			label: t('Підтвердити'),
			requiresConfirmation: true,
			confirmText: t('Ви дійсно хочете підтвердити?'),
			disabled: (status, type) =>
				status !== 'rejected' && type === 'conversion ',
			handler: handlers.approve,
		},
		{
			type: 'reject',
			icon: act02,
			label: t('Відхилити'),
			requiresConfirmation: true,
			confirmText: t('Ви дійсно хочете відхилити замовлення?'),
			disabled: (status) => status === 'confirmed' || status === 'created',
			handler: handlers.reject,
		},
		{
			type: 'confirm',
			icon: check,
			label: t('Підтвердити оплату'),
			disabled: (status) => status === 'confirmed' || status === 'created',
			handler: handlers.confirm,
		},
		{
			type: 'receive',
			icon: check,
			label: t('Підтвердження отримання коштів'),
			disabled: (status) => status !== 'created' && status !== 'rejected',
			handler: handlers.receive,
		},
	];
	const actionsToRender = getAvailableActions(transaction, actions);
	return (
		<>
			<TableButtonsActions
				actions={actionsToRender}
				orderId={transaction.transaction_id}
				orderStatus={transaction.status}
				orderType={transaction.type}
			/>
		</>
	);
};

export default TransactionsActions;
